import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ForbiddenComponent} from '@app/forbidden.component';
import {WebRTCPhoneGuard} from '@app/guards/webrtc-phone.guard';
import {EndUserSearchComponent} from '@app/service-provider/end-user-search/end-user-search.component';
import {WebRTCPhoneComponent} from '@app/shared/webrtc-phone/webrtc-phone.component';

const appRoutes: Routes = [
  {path: 'phone', canActivate: [WebRTCPhoneGuard], component: WebRTCPhoneComponent},
  {path: 'user-search', component: EndUserSearchComponent},
  {path: 'noaccess', component: ForbiddenComponent},
  {
    path: 'callback',
    loadChildren: () => import('./login/login.module').then(mod => mod.LoginModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(mod => mod.LoginModule)
  },
  {
    path: 'conference',
    loadChildren: () => import('./conference/conference.module').then(mod => mod.ConferenceModule)
  },
  {
    path: 'wallboard',
    loadChildren: () => import('./wallboard/wallboard.module').then(mod => mod.WallboardModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(mod => mod.UserModule)
  },
  {
    path: 'swb',
    loadChildren: () => import('./swb/swb.module').then(mod => mod.SwbModule)
  },
  {
    path: 'sms',
    loadChildren: () => import('./sms/sms.module').then(mod => mod.SmsModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(mod => mod.AdminModule)
  },
  {
    path: 'statistics',
    loadChildren: () => import('./statistics/statistics.module').then(mod => mod.StatisticsModule)
  },
  {
    path: 'mss',
    loadChildren: () => import('./mss/mss.module').then(mod => mod.MssModule)
  },

  {path: '', redirectTo: 'user', pathMatch: 'full'},
  {path: '**', redirectTo: 'user'}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
